import { render, staticRenderFns } from "./IRMACapital.vue?vue&type=template&id=9099349a&scoped=true&"
import script from "./IRMACapital.vue?vue&type=script&lang=js&"
export * from "./IRMACapital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9099349a",
  null
  
)

export default component.exports